<script>
    export let monitoringResults, pwsid;
    import NegativeSymbol from './NegativeSymbol.svelte';
    import ResultsChart from './ResultsChart.svelte';
</script>

<div class="chart-group">
    {#if pwsid == "CA1500296"} <!-- Fuller -->
    <h4>Average 1,2,3-TCP level</h4>
    <div class='unit' style="font-weight: 600">in parts per trillion</div>
    <div class="key">
        <div><b class="max"></b>Maximum contaminant level</div>
        <div><b class="goal"></b>Public health goal</div>
    </div>
    <ResultsChart {monitoringResults} tests = 1 analyte = 'tcp'/>

    {:else if pwsid == "CA1510052"} <!-- North Edwards -->
    <h4>North Edwards average arsenic level</h4>
    <div class='unit' style="font-weight: 600">in parts per billion</div>
    <div class="key">
        <div><b class="max"></b>Maximum contaminant level</div>
        <div><b class="goal"></b>Public health goal</div>
    </div>
    <ResultsChart {monitoringResults} tests = 1 analyte = 'arsenic'/>

    {:else if pwsid == "CA1500461"} <!-- Fountain -->
    <h4>Fountain Trailer Park average arsenic level</h4>
    <div class='unit' style="font-weight: 600">in parts per billion</div>
    <div class="key">
        <div><b class="max"></b>Maximum contaminant level</div>
        <div><b class="goal"></b>Public health goal</div>
    </div>
    <ResultsChart {monitoringResults} tests = 1 analyte = 'arsenic'/>

    {:else} <!-- Lakeside -->
    <h4>Average arsenic level</h4>
    <div class='unit' style="font-weight: 600">in parts per billion</div>
    <div class="key">
        <div><b class="max"></b>Maximum contaminant level</div>
        <div><b class="goal"></b>Public health goal</div>
    </div>
    <ResultsChart {monitoringResults} tests = 1 analyte = 'arsenic'/>
    {/if}
</div>
